import React from 'react'

import {
  ItemSelector,
  type ItemSelectorProps,
} from '~/components/elements/ItemSelector'
import { type Survey as SurveyBase } from '~/gql/graphql'

type Survey = App.PickGraphQL<SurveyBase, 'id' | 'title'>

export type SurveySelectorProps<TSurvey extends Survey> = Omit<
  ItemSelectorProps,
  'data' | 'dataItemKey' | 'onChange' | 'textField' | 'value'
> & {
  onChange?: (surveyId: TSurvey['id']) => void
  surveys: TSurvey[]
  value: TSurvey['id'] | null
}

export const SurveySelector = React.forwardRef(
  <TSurvey extends Survey>(
    {
      onChange,
      surveys,
      value: valueProp,
      ...rest
    }: SurveySelectorProps<TSurvey>,
    ref: React.ForwardedRef<HTMLSpanElement>,
  ) => {
    const value = React.useMemo(
      () => surveys.find(({ id }) => id === valueProp),
      [surveys, valueProp],
    )

    const handleChange = React.useCallback<EH<ItemSelectorProps, 'onChange'>>(
      (survey: TSurvey) => {
        onChange?.(survey.id)
      },
      [onChange],
    )

    return (
      <ItemSelector
        ref={ref}
        data={surveys}
        dataItemKey="id"
        textField="title"
        value={value}
        onChange={handleChange}
        {...rest}
      />
    )
  },
)
